require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./libs/element-ui/~/core-js/library/fn/object/assign.js
// module id = 193
// module chunks = 0